import { render, staticRenderFns } from "./paklaring.vue?vue&type=template&id=a6145178&"
import script from "./paklaring.vue?vue&type=script&lang=js&"
export * from "./paklaring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports